import stylesheet_0 from '../stylesheets/0.js';

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.19a6a00e.js","_app/immutable/chunks/scheduler.5b890119.js","_app/immutable/chunks/index.1673eb25.js","_app/immutable/chunks/four_planes.582a9558.js","_app/immutable/chunks/stores.f0dee392.js","_app/immutable/chunks/singletons.f215563a.js","_app/immutable/chunks/index.852d6942.js"];
export const stylesheets = ["_app/immutable/assets/1.5707189e.css"];
export const fonts = [];
export const inline_styles = () => ({
	"_app/immutable/assets/1.5707189e.css": stylesheet_0
});
